/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCreateRequestItemsSchema } from "./banquetCreateRequestItemsSchema.ts";

export const pluginPostbackHealthCheckRequestSchema = z
	.object({
		groupId: z.uuid(),
		plugin_key: z.string().min(1),
		version: z.string().optional().default(""),
		devices: z.array(banquetCreateRequestItemsSchema),
	})
	.describe("Состояние устройств, присланное плагином по своей инициативе.");
